import { sanitizeStructuredContent } from '~/libs/structuredContentSanitizer';
import { settings } from '~/libs/sanitize-amp/settings';

export const sanitizeAmp = (content: (TContent | TScript)[]) =>
  sanitizeStructuredContent(content, settings);
